export default function WhoWeAreNot() {
  const notCards = [
    {
      icon: 'ri-user-forbid-line',
      title: 'Not Beta Testers',
      description: 'We don\'t gather random opinions. CrowdRounds replaces guesswork with structured, multi-layer intelligence.'
    },
    {
      icon: 'ri-survey-line',
      title: 'Not User Surveys',
      description: 'No subjective feedback. No inconsistent results. Your insights come from evidence, scoring, and benchmarks.'
    },
    {
      icon: 'ri-robot-line',
      title: 'Not Cheap AI Tools',
      description: 'We don\'t generate surface-level suggestions. Our 7-system intelligence suite goes far beyond generic AI and uses proprietary success modeling.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Who CrowdRounds® Is NOT
          </h2>
          <p className="text-xl text-slate-600">
            So you know exactly what makes our intelligence different.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {notCards.map((card, index) => (
            <div
              key={index}
              className="relative p-8 bg-gradient-to-br from-slate-50 to-white rounded-2xl border-2 border-slate-200 hover:border-red-400 transition-all duration-300 group"
            >
              <div className="absolute -top-6 left-8">
                <div className="w-12 h-12 bg-gradient-to-br from-red-500 to-red-600 rounded-xl flex items-center justify-center shadow-lg">
                  <i className={`${card.icon} text-2xl text-white`}></i>
                </div>
              </div>
              
              <div className="mt-8">
                <div className="flex items-center gap-2 mb-4">
                  <span className="text-3xl">🚫</span>
                  <h3 className="text-2xl font-bold text-slate-900">
                    {card.title}
                  </h3>
                </div>
                <p className="text-slate-600 leading-relaxed">
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
